import { useRef } from "react";

/**
 * Refs for Instagram canvas preview (hero + carousel add anchor for upload menus).
 */
export function useInstagramCanvasDraft() {
  const mediaUploadRef = useRef<HTMLDivElement | null>(null);
  const carouselAddRef = useRef<HTMLDivElement | null>(null);
  return { mediaUploadRef, carouselAddRef };
}
